import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=6d074ea3&scoped=true&"
import script from "./copy.vue?vue&type=script&lang=ts&"
export * from "./copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d074ea3",
  null
  
)

export default component.exports